import React, { useState, useEffect } from "react";
import styles from "./DateOfBirthInput.module.scss";
import { fromDates, createValueFromParts } from "./date-range-helper";

export interface DateOfBirthInputProps {
  name: string;
  value: string;
  isTouched: boolean;
  showErrorBorder: boolean;
  onChange: (value: string) => void;
  onBlur: (value: string) => void;
  readonly?: boolean;
}
export const DateOfBirthInput = (props: DateOfBirthInputProps) => {
  const [dayValue, setDayValue] = useState("");
  const [monthValue, setMonthValue] = useState("");
  const [yearValue, setYearValue] = useState("");

  const [hasVisitedDay, setHasVisitedDay] = useState(false);
  const [hasVisitedMonth, setHasVisitedMonth] = useState(false);
  const [hasVisitedYear, setHasVisitedYear] = useState(false);

  useEffect(() => {
    if (props.value) {
      const dateParts = props.value.split("-");
      if (dateParts.length === 3) {
        const initialYear = parseInt(dateParts[0]).toString();
        const initialMonth = parseInt(dateParts[1]).toString();
        const initialDay = parseInt(dateParts[2]).toString();
        setDayValue(initialDay);
        setMonthValue(initialMonth);
        setYearValue(initialYear);
      }
    }
    if (props.isTouched) {
      setHasVisitedDay(true);
      setHasVisitedMonth(true);
      setHasVisitedYear(true);
    }
  }, []);

  useEffect(() => {
    if (dayValue && monthValue && yearValue) {
      const currentValue = createValueFromParts(dayValue, monthValue, yearValue);
      props.onChange(currentValue);
    }
  }, [dayValue, monthValue, yearValue]);

  useEffect(() => {
    if (hasVisitedDay && hasVisitedMonth && hasVisitedYear) {
      const currentValue = createValueFromParts(dayValue, monthValue, yearValue);
      props.onBlur(currentValue);
    }
  }, [hasVisitedDay, hasVisitedMonth, hasVisitedYear]);

  function dayPartChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    setDayValue(e.currentTarget.value);
  }
  function dayPartBlur(e: React.FocusEvent<HTMLSelectElement>) {
    if (!hasVisitedDay) {
      setHasVisitedDay(true);
    }
  }
  function monthPartChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    setMonthValue(e.currentTarget.value);
  }
  function monthPartBlur(e: React.FocusEvent<HTMLSelectElement>) {
    if (!hasVisitedMonth) {
      setHasVisitedMonth(true);
    }
  }
  function yearPartChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    setYearValue(e.currentTarget.value);
  }
  function yearPartBlur(e: React.FocusEvent<HTMLSelectElement>) {
    if (!hasVisitedYear) {
      setHasVisitedYear(true);
    }
  }

  // const placeholder = props.field.placeholder ? props.field.placeholder : "";
  const dayElementName = props.name + ".day";
  const monthElementName = props.name + ".month";
  const yearElementName = props.name + ".year";
  return (
    <React.Fragment>
      <div className={styles.container}>
        <div className={styles.fields}>
          <select
            className={styles.day_input}
            value={dayValue}
            id={dayElementName}
            data-name={dayElementName}
            name={dayElementName}
            onChange={dayPartChanged}
            onBlur={dayPartBlur}

          >
            <option className={styles.hide} value="" disabled>
              Day
            </option>
            {fromDates()
              .getDays()
              .map(d => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
          </select>
          <select
            className={styles.month_input}
            value={monthValue}
            onChange={monthPartChanged}
            onBlur={monthPartBlur}
            id={monthElementName}
            name={monthElementName}
            data-name={monthElementName}
            aria-label={monthElementName}
          >
            <option className={styles.hide} value="" disabled>
              Month
            </option>
            {fromDates()
              .getMonths()
              .map(m => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
          </select>
          <select
            className={styles.year_input}
            value={yearValue}
            onChange={yearPartChanged}
            onBlur={yearPartBlur}
            id={yearElementName}
            name={yearElementName}
            data-name={yearElementName}
            aria-label={yearElementName}
          >
            <option className={styles.hide} value="" disabled>
              Year
            </option>
            {fromDates()
              .getYears()
              .map(y => (
                <option key={y.id} value={y.id}>
                  {y.name}
                </option>
              ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
};
